meedy.controller('meedy.availabilityListController', ['$scope', '$state', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.availabilityRuleModel', 'meedy.vacationModel',
    function ($scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, availabilityRuleModel, vacationModel) {

        function setData() {
            $scope.availabilityRulesWrapper = [];
            $scope.vacations = [];
            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.currentUserOriginSystem = userModel.currentUser.originSystem;
            $scope.showAvailableTermType = $scope.currentUserOriginSystem !== Enum.ORIGIN_SYSTEM.MEEDY_PROTECT || ($scope.currentUserOriginSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT && userModel.currentUser.fromPanelAbc);

            $scope.legendItems = [
                {name: "{{ 'T.MEEDY.UI.AVAILABILITY_LEGEND.STATIONARY_VISIT' | translate }}", icon: 'icon-stetoskop-01'},
                {name: "{{ 'T.MEEDY.UI.AVAILABILITY_LEGEND.TRIP_CITY' | translate }}", icon: 'icon-auto-01'},
                {name: "{{ 'T.MEEDY.UI.AVAILABILITY_LEGEND.TRIP_CITY_FAR' | translate }}", icon: 'icon-przod_tyl-01'},
                {name: "{{ 'T.MEEDY.UI.AVAILABILITY_LEGEND.VIDEO_CONSULTATION' | translate }}", icon: 'icon-kula_ziemska-01'}
            ];

            $scope.columns = [
                {
                    cellTemplate: 'meedy/application/view/app/settings/availability/grid-templates/data-availability-list-dayType.html'
                },
                {
                    cellTemplate: 'meedy/application/view/app/settings/availability/grid-templates/data-availability-list-date.html'
                },
                {
                    cellTemplate: 'meedy/application/view/app/settings/availability/grid-templates/data-availability-list-icons.html'
                }
            ];

            $scope.hideAddButton();
            $scope.hideBackButton();
            $scope.resetTitle();

        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULES.SUCCESS, function(event, availabilityRulesWrapper) {
                $scope.availabilityRulesWrapper = availabilityRulesWrapper;

                $scope.availabilityRulesWrapper.forEach(function(wrapper) {
                    if(wrapper.currentAvailabilityRule) {
                        wrapper.currentAvailabilityRule.dayDefinitions = _.sortBy(wrapper.currentAvailabilityRule.dayDefinitions, function (dayDefinition) {
                            switch (dayDefinition.day) {
                                case (Enum.MEEDY.DAY_TYPE.MONDAY) :
                                    return 0 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.TUESDAY) :
                                    return 10000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.WEDNESDAY) :
                                    return 20000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.THURSDAY) :
                                    return 30000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.FRIDAY) :
                                    return 40000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.SATURDAY) :
                                    return 50000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.SUNDAY) :
                                    return 60000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                default:
                                    return 70000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                            }
                        });
                    }
                    wrapper.futureAvailabilityRules.forEach(function(rule) {
                        rule.dayDefinitions = _.sortBy(rule.dayDefinitions, function(dayDefinition) {
                            switch(dayDefinition.day) {
                                case (Enum.MEEDY.DAY_TYPE.MONDAY) :
                                    return 0 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.TUESDAY) :
                                    return 10000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.WEDNESDAY) :
                                    return 20000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.THURSDAY) :
                                    return 30000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.FRIDAY) :
                                    return 40000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.SATURDAY) :
                                    return 50000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                case (Enum.MEEDY.DAY_TYPE.SUNDAY) :
                                    return 60000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                                default:
                                    return 70000 + new Date(dayDefinition.startTime).getHours() * 100 + new Date(dayDefinition.startTime).getMinutes();
                            }
                        })
                    });
                });
            });

            $scope.$on(Event.MEEDY.VACATION.GET_USER_VACATIONS.SUCCESS, function(event, vacations) {
                $scope.vacations = vacations
            });

            $scope.$on(Event.MEEDY.VACATION.DELETE_VACATION.SUCCESS, function(event, data) {
                vacationModel.getUserVacations();
            });

            $scope.$on(Event.MEEDY.AVAILABILITY_RULE.DELETE_AVAILABILITY_RULE.SUCCESS, function(event, data) {
                availabilityRuleModel.getAvailabilityRules();
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
            $scope.createVacation = function() {
                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/settings/availability/popup/vacation-create-popup.html',
                    controller: 'meedy.popupVacationCreateController'
                }).then(function() {
                    vacationModel.getUserVacations();
                }, function(error){

                })
            };

            $scope.createNewAvailability = function(wrapper) {
                if(wrapper.futureAvailabilityRules.length > 0 && wrapper.currentAvailabilityRule) {
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/popup/popup-alert.html',
                        controller: 'meedy.popupAlertController',
                        resolve: {
                            message: function () {
                                return 'T.MEEDY.MODULE.AVAILABILITY.CANNOT_ADD_MORE_AVAILABILITY';
                            },
                            title: function() {
                                return 'T.DATA.ALERT';
                            }
                        }
                    }).then(function () {
                        availabilityRuleModel.getAvailabilityRules();
                    }, function (error) {

                    })
                } else {
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/settings/availability/popup/availability-create-popup.html',
                        controller: 'meedy.popupAvailabilityCreateController',
                        resolve: {
                            resource: function () {
                                return objectHelper.translateObject(wrapper.resourceDTO, ResourceMeedyVO);
                            },
                            currentUserOriginSystem: function() {
                                return $scope.currentUserOriginSystem;
                            }
                        }
                    }).then(function () {
                        availabilityRuleModel.getAvailabilityRules();
                    }, function (error) {

                    });
                }

            };

            $scope.editAvailabilityRule = function(wrapper) {
                var availabilityRuleId = null;

                if(wrapper.currentAvailabilityRule) {
                    availabilityRuleId = wrapper.currentAvailabilityRule.id;
                } else {
                    availabilityRuleId = wrapper.dayDefinitions[0].availabilityRuleId;
                }

                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/settings/availability/popup/availability-edit-popup.html',
                    controller: 'meedy.popupAvailabilityEditController',
                    resolve: {
                        idAvailability: function() {
                            return availabilityRuleId;
                        },
                        resource: function () {
                            return objectHelper.translateObject(wrapper.resourceDTO, ResourceMeedyVO);
                        },
                        currentUserOriginSystem: function() {
                            return $scope.currentUserOriginSystem;
                        }
                    }
                }).then(function() {
                    availabilityRuleModel.getAvailabilityRules();
                }, function(error){

                })
            };

            $scope.deleteAvailabilityRule = function(availabilityRule) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MEEDY.MODULE.AVAILABILITY.AVAILABILITY_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    availabilityRuleModel.deleteAvailabilityRule(availabilityRule);
                }, function() {
                    return false;
                });
            };

            $scope.deleteVacation = function(vacation) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MEEDY.MODULE.AVAILABILITY.VACATION_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    vacationModel.deleteVacation(vacation.id);

                }, function() {
                    return false;
                });
            };

            $scope.getStreetAndNumber = function(address) {
                if(address.apartment) {
                    return address.street + ' ' + address.number + ' / ' + address.apartment;
                }
                return address.street + ' ' + address.number;
            }

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.AVAILABILITY');
        }

        function initialize() {
            availabilityRuleModel.getAvailabilityRules();
            vacationModel.getUserVacations();
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
